<template>  
    <card-seplag> 
      <div class="p-grid p-col-12" style="margin-top:10px;">
          <div class="p-md-6 p-col-12" @click="irParaPendentes">
              <Card class="card-button">
                  <template slot="content">    
                      <div class="p-grid">
                          <div class="p-col-7">
                              <span class="botao-titulo-status">Pendentes</span>
                          </div>
                      </div>                    
                  </template>
              </Card>
          </div>       
          <div class="p-md-6 p-col-12">
              <Card class="card-button estiloValidados">     
                  <template slot="content">    
                      <div class="p-grid">
                          <div class="p-col-7">
                              <span class="botao-titulo-status">Validados</span>
                          </div>
                      </div>                    
                  </template>
              </Card>
          </div>  
      </div>
      <div class="p-grid p-col-12" style="margin-top:10px;">
        <Rotulo cols="12 3" nome="Setor:">
            <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
                placeholder="Selecione..." filter :disabled="false" @change="carregarDados()" />                
        </Rotulo>
      </div>
      <div class="p-grid p-col-12" style="margin-top:10px;">     
        <h1 class="p-col-12">Licenças Validadas</h1>     
        <table-seplag 
                :dados="dadosTabelaPendentes" 
                :exibirCabecalho="false" 
                :paginacao="true"
                :campos="[]"
                :onSearchPaginacao="carregarDados" 
                :totalRegistro="totalRegistro">
                <Column header="Servidor" headerStyle="width: 14em; justify-content: center; "  bodyStyle="text-align: center;">
                    <template #body="slotProps">
                        {{ slotProps.data.nome? slotProps.data.nome : ""}}<br>
                        <span><strong>{{slotProps.data.setor? slotProps.data.setor : ""}}</strong></span>
                    </template>
                </Column>
                <Column header="Período de Aquisitivo" headerStyle="width: 14em;justify-content: center;"  bodyStyle="text-align: center;">
                    <template #body="slotProps">
                        {{slotProps.data.periodoAquisitivo? slotProps.data.periodoAquisitivo : ""}}
                    </template>
                </Column>
                <Column  headerStyle="width: 14em; justify-content: center" bodyStyle="text-align: center" header="Período de Usufruto">
                    <template  #body="slotProps"> 
                        <span>{{slotProps.data.dataInicio}} à {{slotProps.data.dataFim}}</span><br>                   
                    </template>
                </Column>
                <Column  headerStyle="width: 10em; justify-content: center" bodyStyle="justify-content: center" header="Dias de Afastamento">
                    <template #body="slotProps"> 
                        <span>{{slotProps.data.totalDias? slotProps.data.totalDias: "" }} dias </span>  <br>                     
                        <span>(<b>{{ slotProps.data.tipoJornada }}</b>)</span>
                    </template>
                </Column>
                <Column field="status" headerStyle="width: 10em; justify-content: center;" header="Situação" headerClass="situacaoColunaFeriasAgendamento" bodyClass="botaoColunaSituacaoFeriasAgendamento">
                    <template #body="slotProps">
                        <Button
                            :class="'p-button-text status-'+ slotProps.data.status"
                            type="button"
                            @click="showModalJustificativa(slotProps.data.justificativa)"
                            v-tooltip.top="slotProps.data.justificativa?'Ver Justificativa': 'Não Possui Justificativa'" 
                            :label="slotProps.data.status=='VALIDADO'? 'NO SEAP' : slotProps.data.status=='APROVADORH'? 'APROVADO' :slotProps.data.status"
                        />
                    </template>
                </Column>                  
            </table-seplag>   
      </div>                
            
        <cadastro-rapido
        tituloTela="Justificativa"
        :tamanhoTela="'30.vw'"
        v-model="exibirTelJustificativa"
        textoButtonFechar="Fechar"
        :visivelbotao="true"
        >
            
            <p
                style="text-align: justify"
                v-html="
                justificativaSelecionada ? justificativaSelecionada : 'Não Informado'
                "
            />
        </cadastro-rapido>        
    </card-seplag>
  </template>
  
  <script>
  
  import CardSeplag from '@/template/CardSeplag.vue'
  import CadastroRapido from '@/template/CadRapidoSeplag.vue'
  import Rotulo from '@/template/RotuloSeplag.vue'
  import TableSeplag from '@/template/TableSeplag.vue'
  import { baseApiUrl } from '@/config/global'
  
  export default {
      name:"ChefiaValidadosLicenca",
      components: { CardSeplag, CadastroRapido, Rotulo, TableSeplag },    
      data (){
          return{   
            dadosTabelaPendentes: [],
            totalRegistro: 0,
            tamanhoPorpagina: 10,
            urlPaginacao: '',
            motivoRejeicao: [],
            exibirTelJustificativa: false,
            justificativaSelecionada: null,
            dadosAprovacao: null, 
            listaUnidades: null,
            unidadeSelecionada: null,
            v_agendamentos: null
          }
      },                   
      methods: {     
        async carregarDados(size=10, page=0){ 
            // var v_agendamentos  = await this.$http.get(`${baseApiUrl}/lincencaview/chefia/lista/${this.$store.getters.getMatricula}/${this.$store.getters.getVinculo}/VALIDADOS?size=${size}&page=${page}`)
            const matricula = this.$store.getters.getMatricula
            const vinculo = this.$store.getters.getVinculo
            const urlPaginacao = `lincencaview/chefia/lista/${matricula}/${vinculo}/VALIDADOS`

            // Buscar unidades
            await this.$http.get(`${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${matricula}/${vinculo}`).then(respUnidades => {                    
                this.listaUnidades = respUnidades.data.map(function (element) {
                    return {
                        ...element,
                        labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
                    };
                });
            })
            

            this.unidadeSelecionada = this.unidadeSelecionada ? this.unidadeSelecionada : this.listaUnidades[0]

            // Buscar licenças
            await this.$http.get(`${baseApiUrl}/${urlPaginacao}/${this.unidadeSelecionada.codgSeap}?size=${size}&page=${page}`).then(respLicencas =>{
                this.v_agendamentos = respLicencas
                this.dadosTabelaPendentes = respLicencas.data.content
                this.totalRegistro = respLicencas.data.totalElements
            })


            if(this.v_agendamentos.status==200) {
                this.dadosTabelaPendentes = []
                this.totalRegistro = this.v_agendamentos.data.totalElements;
                for(var item in this.v_agendamentos.data.content) {
                    let aprovador = null;
                    if(this.v_agendamentos.data.content[item].aprovador){
                        aprovador = JSON.parse(this.v_agendamentos.data.content[item].aprovador)
                    }
                    var v_programacao = {
                        'setor': this.v_agendamentos.data.content[item].setor,
                        'nome': this.v_agendamentos.data.content[item].nome,                        
                        'periodoAquisitivo' : this.v_agendamentos.data.content[item].dataInicioPeraq+" à "+this.v_agendamentos.data.content[item].dataFimPeraq,
                        'totalDias' : this.v_agendamentos.data.content[item].totalDias,
                        'dataInicio' : this.v_agendamentos.data.content[item].dataInicio,
                        'dataFim' : this.v_agendamentos.data.content[item].dataFim,
                        'status' : this.v_agendamentos.data.content[item].statusPortal,
                        'tipoJornada' : this.v_agendamentos.data.content[item].periodoJornadaReduzida? "REDUZIDA": "INTEGRAL",
                        'justificativa': this.v_agendamentos.data.content[item].obs,
                        'aprovador' :  this.v_agendamentos.data.content[item].aprovador &&  aprovador? aprovador.nome : '',
                        'aprovadorUnidade' : this.v_agendamentos.data.content[item].aprovador &&  aprovador? aprovador.setor : ''
                    }
                    this.dadosTabelaPendentes.push(v_programacao)
                }
                
            }
          },
          fecharModal(){           
              this.justificativaSelecionada = null
              this.exibirTelJustificativa = false
          },
        showModalJustificativa(justificativa){
            if(justificativa){
                this.justificativaSelecionada = justificativa;
                this.exibirTelJustificativa = true;
            }else{                
                this.$toast.add({
                severity: 'error',
                summary:'justificativa Não Cadastrada',
                life: 3000,
                });
            }
        },
        irParaPendentes(){
            this.$router.push({ name: 'ChefiaPendentesLicenca' })
        }
      },
      mounted(){
          // Carrega os dados do serviço
          this.carregarDados()
      }
  }
  
  </script>
  
  <style scoped>
  
  .estiloValidados {
    background: rgb(71, 139, 25);
    color: aliceblue;
  }
  
  .card-button{    
      cursor: pointer;
  }
  
  .botao-titulo-status{    
      font-size: 15px;
      font-weight: bold;
  }
  
  .customer-badge-validados {
      border-radius: 2px;
      padding: .25em .5em;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 12px;
      letter-spacing: .3px;
      background-color:  rgb(219, 171, 81);
      color: aliceblue;
  }
  .customer-badge {
        border-radius: 2px;
        padding: .25em .5em;
        text-transform: uppercase;
        font-weight: 700;
        font-size: 12px;
        letter-spacing: .3px;
    }
    .status-APROVADO {
        background-color: #C8E6C9;
        color: #256029;
    }
    
    .status-APROVADO:active {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADO:hover {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADO:focus {
        box-shadow: 0 0 0 0.2rem #c8e6c9 ;
    }
    .status-APROVADORH {
        background-color: #C8E6C9;
        color: #256029;
    }
    
    .status-APROVADORH:active {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADORH:hover {
        background-color: #C8E6C9 !important;
        color: #256029 !important;
    }        
    
    .status-APROVADORH:focus {
        box-shadow: 0 0 0 0.2rem #c8e6c9 ;
    }

    .status-REPROVADO {
        background-color: #FFCDD2;
        color: #C63737;
    }
    
    .status-REPROVADO:active {
        background-color: #FFCDD2 !important;
        color: #C63737 !important;
    }        
    
    .status-REPROVADO:hover {
        background-color: #FFCDD2 !important;
        color: #C63737 !important;
    }        
    
    .status-REPROVADO:focus {
        box-shadow: 0 0 0 0.2rem #FFCDD2 ;
    }

    .status-PENDENTE {
        background-color: #FEEDAF;
        color: #8A5340;
    }
    
    .status-PENDENTE:active {
        background-color: #FEEDAF !important;
        color: #8A5340 !important;
    }        
    
    .status-PENDENTE:hover {
        background-color: #FEEDAF !important;
        color: #8A5340 !important;
    }        
    
    .status-PENDENTE:focus {
        box-shadow: 0 0 0 0.2rem #FEEDAF ;
    }

    .status-PUBLICADO {
        background-color: #B3E5FC;
        color: #23547B;
    }
    
    .status-PUBLICADO:active {
        background-color: #B3E5FC !important;
        color: #23547B !important;
    }        
    
    .status-PUBLICADO:hover {
        background-color: #B3E5FC !important;
        color: #23547B !important;
    }        
    
    .status-PUBLICADO:focus {
        box-shadow: 0 0 0 0.2rem #B3E5FC ;
    }

    .status-VALIDADO {
        background-color: #ECCFFF;
        color: #694382;
    }
    
    .status-VALIDADO:active {
        background-color: #ECCFFF !important;
        color: #694382 !important;
    }        
    
    .status-VALIDADO:hover {
        background-color: #ECCFFF !important;
        color: #694382 !important;
    }        
    
    .status-VALIDADO:focus {
        box-shadow: 0 0 0 0.2rem #ECCFFF ;
    }

    .status-VIASEAP {
    background-color: #b4b3af;
    color: #3f3e3d;
    }

    .status-VIASEAP:active {
    background-color: #b4b3af !important;
    color: #3f3e3d !important;
    }

    .status-VIASEAP:hover {
    background-color: #b4b3af !important;
    color: #3f3e3d !important;
    }

    .status-VIASEAP:focus {
    box-shadow: 0 0 0 0.2rem #b4b3af;
    }

    .status-EFETIVADO {
    background-color: #b3e5fc;
    color: #23547b;
    }

    .status-EFETIVADO:active {
    background-color: #b3e5fc !important;
    color: #23547b !important;
    }

    .status-EFETIVADO:hover {
    background-color: #b3e5fc !important;
    color: #23547b !important;
    }

    .status-EFETIVADO:focus {
    box-shadow: 0 0 0 0.2rem #b3e5fc;
    }

    .status-proposal {
        background-color: #FFD8B2;
        color: #805B36;
    }
  
  </style>